// Mirrors backend: core/workflow/incept/Ppsr/Enums/OrganisationNumberType.php
export enum OrganisationNumberType {
  NonStandard = 'non_standard',
  ACN = 'acn',
  ARBN = 'arbn',
  ARSN = 'arsn',
  ABN = 'abn',
  NameOnly = 'name_only',
}

export const ORGANISATION_NUMBER_TYPE_LABELS: Record<
  OrganisationNumberType,
  string
> = {
  [OrganisationNumberType.NonStandard]: 'Non-Standard',
  [OrganisationNumberType.ACN]: 'ACN',
  [OrganisationNumberType.ARBN]: 'ARBN',
  [OrganisationNumberType.ARSN]: 'ARSN',
  [OrganisationNumberType.ABN]: 'ABN',
  [OrganisationNumberType.NameOnly]: 'Name Only',
};
